// MUNYA OS · Inicializa atajos teclado + escucha focus mode toggle
// § 18.4-11 (A3) + § 18.4-15 (A4)

import { useEffect, type ReactElement } from 'react';
import { navigate } from '../lib/router.js';
import { keyboardShortcuts } from '../lib/keyboard-shortcuts.js';
import { ShortcutsCheatSheet } from './ShortcutsCheatSheet.js';

const FOCUS_STORAGE_KEY = 'mn:focus-mode';

function applyFocusMode(enabled: boolean): void {
  document.documentElement.classList.toggle('munya-focus-mode', enabled);
  localStorage.setItem(FOCUS_STORAGE_KEY, enabled ? '1' : '0');
}

export function ShortcutsRoot(): ReactElement {
  useEffect(() => {
    const unregister = keyboardShortcuts.init((path) => {
      navigate(path);
    });
    const offFocus = keyboardShortcuts.onFocusToggle(() => {
      const current = document.documentElement.classList.contains('munya-focus-mode');
      applyFocusMode(!current);
    });
    // Restaurar estado focus mode del localStorage
    const saved = localStorage.getItem(FOCUS_STORAGE_KEY) === '1';
    if (saved) applyFocusMode(true);

    return () => {
      unregister();
      offFocus();
    };
  }, []);

  return <ShortcutsCheatSheet />;
}
